import { escapeHtml, formatDate, formatFileSegment, todayISO } from "./controleFormat";

function reportCommentForPatientIssue(issue, launchStatusLabel) {
    const comment = issue.comment?.trim();
    if (comment) return comment;
    if (issue.pointKey === "tracageLogiciels") {
        return launchStatusLabel(issue.launchStatus);
    }
    return "Commentaire non renseigné.";
}

export function generateBlockingPatientIssuesPdfHtml({ dossier, ehpadName, issues, launchStatusLabel }) {
    const generatedAt = new Date().toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
    const rows = (issues || []).map(issue => `
        <tr>
            <td>${escapeHtml(issue.patientName)}</td>
            <td>${escapeHtml(issue.room || "—")}</td>
            <td class="comment">${escapeHtml(reportCommentForPatientIssue(issue, launchStatusLabel))}</td>
        </tr>
    `).join("");
    const reportTitle = "Rapport dossier de lot de production";
    return `<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <title>${escapeHtml(reportTitle)}</title>
    <style>
        @page { margin: 1.5cm; }
        @media screen { body { margin: 1.5cm; } }
        @media print { body { margin: 0; } }
        body { font-family: Arial, sans-serif; color: #111827; font-size: 12px; line-height: 1.5; }
        h1 { margin: 0 0 8px; font-size: 20px; color: #0f172a; }
        .meta { display: grid; grid-template-columns: 140px 1fr; gap: 6px 12px; margin: 16px 0 22px; padding: 12px; border: 1px solid #cbd5e1; border-radius: 6px; background: #f8fafc; }
        .label { font-weight: 700; color: #475569; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #f1f5f9; color: #334155; text-align: left; font-size: 11px; text-transform: uppercase; letter-spacing: 0.03em; }
        th, td { border: 1px solid #cbd5e1; padding: 8px; vertical-align: top; }
        tr { break-inside: avoid; page-break-inside: avoid; }
        .comment { white-space: pre-wrap; }
        .empty { padding: 18px; border: 1px dashed #cbd5e1; border-radius: 6px; color: #64748b; text-align: center; }
        .footer { margin-top: 28px; color: #64748b; font-size: 10px; }
    </style>
</head>
<body>
    <h1>${escapeHtml(reportTitle)}</h1>
    <div class="meta">
        <div class="label">EHPAD</div><div>${escapeHtml(ehpadName || "Non renseigné")}</div>
        <div class="label">Date production</div><div>${escapeHtml(formatDate(dossier?.dateProduction))}</div>
        <div class="label">Dossier de lot</div><div>${escapeHtml(dossier?.numeroLot || "Non renseigné")}</div>
        <div class="label">Patients concernés</div><div>${escapeHtml((issues || []).length)}</div>
        <div class="label">Édité le</div><div>${escapeHtml(generatedAt)}</div>
    </div>
    ${(issues || []).length > 0 ? `
        <table>
            <thead>
                <tr>
                    <th>Patient</th>
                    <th>Chambre</th>
                    <th>Commentaires</th>
                </tr>
            </thead>
            <tbody>${rows}</tbody>
        </table>
    ` : `<div class="empty">Aucun patient à reprendre.</div>`}
    <div class="footer">Document généré depuis l'onglet Contrôle.</div>
</body>
</html>`;
}

export function openBlockingPatientIssuesPdf({ dossier, ehpadName, issues, launchStatusLabel }) {
    const html = generateBlockingPatientIssuesPdfHtml({ dossier, ehpadName, issues, launchStatusLabel });
    const blob = new Blob([html], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    const filename = `rapport-dossier-lot-production-${formatFileSegment(ehpadName)}-${dossier?.dateProduction || todayISO()}`;
    const win = globalThis.open(url, "_blank", "width=900,height=700");
    if (!win) {
        URL.revokeObjectURL(url);
        return;
    }
    win.addEventListener("load", () => {
        URL.revokeObjectURL(url);
        try {
            win.document.title = `${filename}.pdf`;
        } catch { /* cross-browser print preview title fallback */ }
        win.focus();
        win.print();
    }, { once: true });
}
